import React from 'react';
import styles from './styles.css';

const fonasuHelpText =
  'Please complete each section and click Done before moving on to edit/complete other sections to ensure all data is saved.';

const FONASUHelpText = () => (
  <>
    <div className="help-text">{fonasuHelpText}</div>
    <style jsx>{styles}</style>
  </>
);

FONASUHelpText.defaultProps = {
  text: ''
};

export default FONASUHelpText;
